import I18n from 'lib/i18n/i18n';
import {
    rootUrl,
    PENDING_AUCTION,
    PENDING_SALE,
    RETURN_PENDING,
    EVALUATION_READY,
    ON_HOLD,
    SALE_SCHEDULED,
    EVALUATION_BID,
    EVALUATION_BID_ASSORTED,
    DONE,
    SHIPPED_BACK_TO_SELLER,
    IN_TRANSIT,
    PICKUP_WAITING,
    SHIPPING,
    ADDRESS_WAITING,
    BIDDING_FINISHED,
    EVALUATED,

    capitalize_words,
    DELIVERED, isMobile
} from "../helpers/ApplicationHelper";
import WorthyApi from "../lib/api/worthyApi";

//     -20 => 'No Touch',
//     -10 => 'Low Touch',
//     0 => 'Standard',
//     1 => 'High Value',
//     2 => 'Ultra Expensive',
//     3 => 'Super Expensive',

export function siteItemPage(public_id) {
    return rootUrl(`/items/${public_id}`);
}

export function getAuctionChanceOfSuccess(value, recommendedPrice) {
    let stepsMap = I18n.getVar('common::auction::successPercentageSteps'),
        step;
    for (step in stepsMap)
        if (value < (recommendedPrice * (parseInt(step)) / 100)) break;
    return parseInt(stepsMap[step]);
}

/**
 *
 * @param item
 * @returns {*}
 */
export function haveProperties(item){
    return item.not_empty;
}

export const ONLINE_CANCELLATION_REASON_NUMBER = 42;

export const LABS_LOCATION_NAMES = ['gia', 'igi', 'gsi'];

function allItemsFinished (bundle) {
    return bundle.items ? bundle.items.every((item) => {
        return [
            ON_HOLD,
            PENDING_SALE,
            EVALUATION_READY,
            SALE_SCHEDULED,
            RETURN_PENDING,
            DONE
        ].includes(item['workflow_state'])
    }) : false;
}

export const photosInSameLine = (item) => {

    if (item.photos || !item.photos.length ) {
        return isMobile() ? item.workflow_state === SHIPPING && item.bundle.workflow_state === PICKUP_WAITING && !item.photos.length
            : item.photos.length <= 1;
    }
    return false;
};

function anyItemInAuction (bundle) {
    return bundle.items ? bundle.items.filter(item => [EVALUATION_BID, BIDDING_FINISHED].includes(item['workflow_state'])).length : false;
}

export const getStatus = (bundle, item, version = 1) => {
    // Version 1 stands for Bundle states (which may be an One-item bundles or JB)
    // Version 2 stands for Item states (inside bundles, like JB)
    const startOfAuctionStatuses = [PENDING_AUCTION, PENDING_SALE].includes(item.workflow_state);
    // FIXME: “Processing” in JB =>  “At Worthy offices NYC“ (Single item)
    const bundleType = bundle.type;
    const allFinished = allItemsFinished(bundle);
    const anyInAuction = anyItemInAuction(bundle);
    if (item.workflow_state === PENDING_AUCTION && item.format === 'tender')
        return 'Processing';
    if (item.major_subset_type === 'Watch') {
        if ([
            PENDING_AUCTION,
            PENDING_SALE,
            EVALUATION_READY,
            BIDDING_FINISHED
        ].includes(item.workflow_state)) {
            // Show offer
            return 'Auction'
        } else if (EVALUATION_BID === item.workflow_state) {
            return 'Live auction'
        } else if ([ON_HOLD, SALE_SCHEDULED, DONE].includes(item.workflow_state)) {
            return item.reject_reason === ONLINE_CANCELLATION_REASON_NUMBER ? 'Cancelled' : item.aborted ? 'Aborted' : 'Sold';
        } else if (bundle.pickup_time_range || bundle.shipment_method === 'Dropoff') {
            if (bundle.pickup_time_range) {
                return `Pickup scheduled for ${ bundle.pickup_time_range }`
            } else return 'Awaiting dropoff'
        } else {
            return 'Pending'
        }
    }

    if (version === 1 && bundleType === 'jewelry_box' && item.restrict_jb_seller_from_entering_auction_const && anyInAuction) return 'In auction';
    else if (version === 1 && bundleType === 'jewelry_box' && item.restrict_jb_seller_from_entering_auction_const && startOfAuctionStatuses) return 'Processing';
    else if (bundle.pickup_time_range || bundle.shipment_method === 'Dropoff') {
        if (bundle.pickup_time_range) {
            return `Pickup scheduled for ${ bundle.pickup_time_range }`
        } else return 'Awaiting dropoff'
    }
    else if ((version === 1 && bundleType === 'jewelry_box' || bundle.expensive_item) && bundle.appointment_time) return `Call scheduled for ${bundle.appointment_time}`
    else if (item.workflow_state === DELIVERED && item.location === 'worthy_ny') return version === 1 ? 'Processing' : 'At Worthy offices NYC';
    else if (item.workflow_state === DELIVERED && item.location === 'cleaning') return 'Cleaning';
    else if (item.workflow_state === DELIVERED && item.location === 'photography') return 'Photography';
    else if (item.workflow_state === DELIVERED && item.location && item.location.includes('diamond_remove')) return 'Unmounting';
    else if (LABS_LOCATION_NAMES.includes(item.location)) return `Grading at ${item.location.toUpperCase()}`;
    else if (item.location === 'central_watch') return `Grading at ${capitalize_words(item.location.replace(/_/g, ' '))}`;
    else if (item.return_requested) return 'Return requested';
    else if (item.pending_buyer_response) return 'Pending buyer response';
    else if (item.workflow_state === PENDING_AUCTION) return 'Pending auction';
    else if (item.workflow_state === EVALUATION_BID) return version === 1 ? 'Active auction' : 'Live auction';
    else if (item.workflow_state === EVALUATION_BID_ASSORTED) return 'In progress';
    else if ([EVALUATION_READY, PENDING_SALE, BIDDING_FINISHED].includes(item.workflow_state))
        if (allFinished || bundle.workflow_state === EVALUATED) return version === 1 ? 'Concluded' : 'See Offer';
        else return 'In progress';
    else if ([ON_HOLD, SALE_SCHEDULED, DONE].includes(item.workflow_state))
       if(item.reject_reason === ONLINE_CANCELLATION_REASON_NUMBER) return 'Cancelled';
       else if (item.aborted) return 'Aborted';
        else if (bundleType === 'standard')
            if (!item.minimum_price_met) return version === 1 ? 'Concluded and approved' : 'Sold';
            else return version === 1 ? 'Concluded, Above reserve' : 'Sold';
        else return version === 1 ? 'Concluded' : 'Sold';
    else if (item.workflow_state === RETURN_PENDING) return 'Pending return';
    else if (item.location === SHIPPED_BACK_TO_SELLER) return 'Shipped back';
};

export const isJBLeads = (item) => {
    return (
        item?.bundle?.jb ||
        item?.bundle?.converted_from_std_bundle ||
        item?.additional_items?.length > 1 ||
        item?.bundle_type === 'jewelry_box'
    );
};

export const isHighValueLeads = (item) => {
    return ['High Value', 1].includes(item?.value_category) || item?.high_value_estimation;
};

export const isUltraValueLeads = (item) => {
    return ["Ultra Expensive", "Super Expensive", 2, 3].includes(item?.value_category);
};

export const itemCertificateDetails = (item) => {
    const preDeliveryItemStates = [
        "submission",
        "validation_needed",
        "estimation_ready",
        "shipping",
        "in_transit",
    ];
    const hasCertificate =
        item.certificate &&
        item.certificate.provider &&
        item.certificate.number;

    const canAddCertificate =
        !hasCertificate &&
        preDeliveryItemStates.includes(item.workflow_state) &&
        item.item_type_name !== "Luxury Watches";

    const canEditCertificate = false;
    const canDeleteCertificate = false;
    const showCertificateField = hasCertificate || canAddCertificate;

    return {
        hasCertificate,
        canAddCertificate,
        canEditCertificate,
        canDeleteCertificate,
        showCertificateField,
    };
}
